module.exports = __webpack_public_path__ + "static/media/quickconnect.db128411.jpg";